export default {
  AccessHistory: {
    TitleList: 'Nhật ký truy cập',
    From: 'Từ',
    To: 'Đến',
  },
};
